module.exports = __webpack_public_path__ + "static/media/shipsy.a223355c.png";